import { render, staticRenderFns } from "./buyShebeiInfo.vue?vue&type=template&id=7151859a&scoped=true&"
import script from "./buyShebeiInfo.vue?vue&type=script&lang=js&"
export * from "./buyShebeiInfo.vue?vue&type=script&lang=js&"
import style0 from "./buyShebeiInfo.vue?vue&type=style&index=0&id=7151859a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7151859a",
  null
  
)

export default component.exports